import React from "react";
import logoone from "../../../Assets/Logos/logo-hand.png";
import logotwo from "../../../Assets/Logos/logo-one.png";
import AboutHeadings from "./AboutHeadings";

const AboutOurPhilosophy = () => {
  const ethics = [
    {
      logo: logoone,
      heading: " Our Story",
      about: `Every big change begins with a small step of kindness.
AAFSA was born with the belief that humanity knows no boundaries – of caste, creed, or religion, haves & havenots. We stand with the marginalized, the forgotten, and the voiceless to ensure that hope reaches every corner of society.
`,
    },
    {
      logo: logotwo,
      heading: "Our Mission",
      about:
        "To empower communities, restore dignity, and open doors of opportunity for those who need it most – creating a future where everyone can thrive.",
    },
  ];

  return (
    <div className="py-10 px-4 md:px-[5rem] w-full h-auto">
      <AboutHeadings title={"Our Philosophy, Commission and Ethics"} />

      <div className="grid gap-6 md:grid-cols-2 py-6">
        {ethics.map((item, index) => (
          <div
            key={index}
            className="bg-[#ECF8FB] rounded-2xl p-6 shadow-md flex items-center gap-4 transform transition-transform duration-500 hover:scale-105 hover:shadow-xl"
            data-aos="fade-up"
            data-aos-delay={index * 200} // stagger effect
            data-aos-duration="1000"
          >
            <div className="flex-shrink-0">
              <img
                src={item.logo}
                alt="logo"
                className="w-16 h-16 md:w-20 md:h-20 object-contain"
              />
            </div>

            <div className="flex flex-col">
              <h3 className="text-lg md:text-xl font-semibold text-[#08121A] mb-2">
                {item.heading}
              </h3>
              <p className="text-sm md:text-base text-[#4D4D4D] leading-relaxed tracking-wide">
                {item.about}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutOurPhilosophy;
